module.exports = __webpack_public_path__ + "static/media/daemon-skull.e1dfd4c9.svg";